import React from 'react';
import loading from "../../media/loading_compressed_super.gif";

const Loading = () => {
    return (
        <div className="loading">
            <img alt="Loading" className="loading-src" src={loading} />
        </div>
    );
};


export default Loading;
